import { CircleImage } from './SuggestionImage.styles';

export const SuggestionImage = ({ imagePath }: { imagePath: string }) => (
  <CircleImage
    src={imagePath}
    htmlAttributes={{ draggable: false }}
    imgixParams={{
      fit: 'facearea',
      facepad: 1.4,
    }}
    width={32}
    height={32}
  />
);
